var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-1 overflow-auto"},[_c('pre-chat-form',{attrs:{"options":_vm.preChatFormOptions},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }